import app from 'flarum/forum/app';
import EventPost from 'flarum/forum/components/EventPost';

export default class ReservedSlotPost extends EventPost {
  icon() {
    return 'fas fa-music';
  }

  descriptionKey() {
    return 'pianotell-recitals.forum.reserved_slot_description';
  }

  descriptionData() {
    var content = this.attrs.post.content() || {};
    return { slotNumber: content.slotNumber || '?' };
  }
}
